import { ERROR, LOADING, LOADED } from 'data/actions/projects';

const INITIAL_STATE = {
    all: [],
    isLoading: false,
    hasLoaded: false,
    hasError: false
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case ERROR:
            return { ...state, hasError: action.error };
        case LOADING:
            return { ...state, isLoading: action.isLoading };
        case LOADED:
            return { ...state, all: action.payload, hasLoaded: true };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/data/reducers/projects.js